var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "@irati/utils/lang";
import history from "@irati/utils/history";
import Routes, { SETUP_TENANT } from "@irati-web/app/src/routeConfig";
import Icon from "@irati/ui/src/Icon";
import { TENANT_SETUP_TOUR_PREFIX } from "../../tour";
import { isPathActive, getCurrentTenantSetupStepConfig } from "../../helpers";
import { InviteAdminWrapper, SpacedPara } from "./styled";
var InviteAdmin = /** @class */ (function (_super) {
    __extends(InviteAdmin, _super);
    function InviteAdmin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var lastVisitedStep = getCurrentTenantSetupStepConfig();
            if (lastVisitedStep) {
                var lastVisitedStepPath = lastVisitedStep.nestedPath;
                history.push({
                    pathname: Routes[SETUP_TENANT] + "/invite-admin",
                    state: {
                        lastVisitedStepPath: lastVisitedStepPath
                    }
                });
            }
            else {
                history.push(Routes[SETUP_TENANT] + "/invite-admin");
            }
        };
        return _this;
    }
    InviteAdmin.prototype.render = function () {
        return (React.createElement(InviteAdminWrapper, { "data-tour": TENANT_SETUP_TOUR_PREFIX + "step03", alignItems: "center", onClick: this.handleClick, active: isPathActive("invite-admin") },
            React.createElement(Icon, { size: 30, icon: "addAdmin" }),
            React.createElement(SpacedPara, { flush: true },
                React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.title" }))));
    };
    return InviteAdmin;
}(PureComponent));
export default withRouter(InviteAdmin);
